
export const removeProtocol = url => {
    return typeof url === 'string' ? url.replace(/htt(p|ps):\/\//, '') : url;
};